import { useEffect, useState } from "react";

const TOKEN = "stravex_token";
const USER = "stravex_user";
const NEXT = "stravex_next";
const listeners = new Set();

function readUser() {
  try {
    return JSON.parse(window.sessionStorage.getItem(USER) || "null");
  } catch {
    return null;
  }
}

export function getToken() {
  return window.sessionStorage.getItem(TOKEN) || "";
}

export function getUser() {
  return readUser();
}

export function setSession(token, user) {
  if (token) {
    window.sessionStorage.setItem(TOKEN, token);
    window.sessionStorage.setItem(USER, JSON.stringify(user || null));
  } else {
    window.sessionStorage.removeItem(TOKEN);
    window.sessionStorage.removeItem(USER);
  }
  listeners.forEach((listener) => listener());
}

export function clearSession() {
  setSession("", null);
}

export function rememberNext(hash) {
  if (hash) window.sessionStorage.setItem(NEXT, hash);
}

export function takeNext() {
  const next = window.sessionStorage.getItem(NEXT) || "#/dashboard";
  window.sessionStorage.removeItem(NEXT);
  return next;
}

const NOTE = "stravex_note";

export function setNote(text) {
  if (text) window.sessionStorage.setItem(NOTE, text);
}

export function takeNote() {
  const text = window.sessionStorage.getItem(NOTE) || "";
  window.sessionStorage.removeItem(NOTE);
  return text;
}

export function useSession() {
  const [, setTick] = useState(0);
  useEffect(() => {
    const update = () => setTick((value) => value + 1);
    listeners.add(update);
    return () => listeners.delete(update);
  }, []);
  return { token: getToken(), user: getUser() };
}
